import Image from 'next/image';
import React from 'react';
import NavbarMenuItems from '@/app/components/navbar-menu-items';
import { NavbarMenu, NavbarMenuToggle } from '@heroui/react';
import { Links } from '@/app/utils/links';

type MobileNavbarMenuProps = {
  links: Links;
  isMenuOpen: boolean;
};

export default function MobileNavbarMenu({
  links,
  isMenuOpen,
}: MobileNavbarMenuProps) {
  return (
    <div className="md:hidden">
      <NavbarMenuToggle
        icon={
          isMenuOpen ? (
            <Image
              data-testid="close-menu-icon"
              src="/images/close-menu-icon.svg"
              alt="close menu icon"
              width={16}
              height={16}
              className="min-w-[16px] min-h-[16px]"
            />
          ) : (
            <Image
              data-testid="burge-menu-icon"
              src="/images/burger-menu-icon.svg"
              alt="burger menu icon"
              width={16}
              height={16}
              className="min-w-[16px] min-h-[16px]"
            />
          )
        }
      />
      <NavbarMenu className="bg-[var(--color-navigation-main)]  px-4">
        <NavbarMenuItems links={links} />
        <div className="absolute bottom-0 right-0 p-0">
          <Image
            data-testid="menu-logo"
            src="/images/menu-logo.svg"
            alt="greens logo"
            width={220}
            height={220}
          />
        </div>
      </NavbarMenu>
    </div>
  );
}
